import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

async function fetchAppointmentReminderSettings() {
  const response = await axios.get('settings/appointment-reminders');
  return response.data;
}

export default function useAppointmentReminderSettings() {
  return useQuery(
    ['appointment-reminder-settings'],
    fetchAppointmentReminderSettings,
  );
}
